<template>
    <div>
        <h1 class="display-heading">Submit Manual Reimbursement</h1>

        <div class="card mb-3">
            <div class="card-header">Request Manual Reimbursement</div>
            <div class="card-body">
                <router-link :to="{
                    'name': 'user-manual-reimbursement-add',
                }" class="btn btn-primary btn-primary-insv mr-2">
                    Request Manual Reimbursement
                </router-link>
            </div>
        </div>

        <div class="d-flex align-items-baseline">
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Patient Name:</label>
                <input style="width: 150px" type="text" ref="filterName" name="filterName" data-vv-as="filter patient name" data-vv-validate-on="blur"
                    v-model="filterName" v-validate="''"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterName')
                    }">
                <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                    {{ validationErrors.first('filterName') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">From Date:</label>
                <input style="width: 150px" type="text" name="filterFromDate" ref="filterFromDate" data-vv-as="filter from date" data-vv-validate-on="blur"
                    v-model="filterFromDate" placeholder="DD/MM/YYYY" v-mask="'##/##/####'" v-validate="'date_format:DD/MM/YYYY'"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterFromDate')
                    }">
                <div v-show="validationErrors.has('filterFromDate')" class="invalid-feedback">
                    {{ validationErrors.first('filterFromDate') }}
                </div>
            </div>
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">To Date:</label>
                <input style="width: 150px" type="text" name="filterToDate" ref="filterToDate" data-vv-as="filter to date" data-vv-validate-on="blur"
                    v-model="filterToDate" placeholder="DD/MM/YYYY" v-mask="'##/##/####'" v-validate="'date_format:DD/MM/YYYY'"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterToDate')
                    }">
                <div v-show="validationErrors.has('filterToDate')" class="invalid-feedback">
                    {{ validationErrors.first('filterToDate') }}
                </div>
            </div>
            <button @click="getManualReimbursements" class="btn btn-primary">Search</button>
        </div>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col>
                    <col width="200">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Patient Name</th>
                            <th scope="col">Requested Amount</th>
                            <th scope="col">Consultation Date</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="manualReimbursementList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(manualReimbursement, index) in manualReimbursementList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                            <td>{{manualReimbursement.patientName}}</td>
                            <td>{{manualReimbursement.requestAmount.toFixed(2)}}</td>
                            <td>{{manualReimbursement.reimbursementDate}}</td>
                            <td>
                                <span class="badge text-nowrap" :class="manualReimbursement.statusBadgeClass">
                                    {{ manualReimbursement.statusDisplay }}
                                </span>
                            </td>
                            <td>
                                <router-link :to="{
                                    'name': 'user-manual-reimbursement-detail',
                                    'params': {'id': manualReimbursement.manualReimbursementId}
                                }">
                                View Details
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import 'daterangepicker/daterangepicker';
import {
    convertDateToDDMMYYYY,
    convertDateToIso8601
} from '@/utilities';
import benefitDateSettings from '@/components/benefit-date-settings';
import pagination from '@/components/pagination';
import popupModal from '@/components/popup-modal';
import {
    genericStatus,
    getEnumDisplay,
    getEnumBadgeClass
} from '@/config/enums';
import {
    mask
} from 'vue-the-mask';
export default {
    'name': 'ManualReimbursementList',
    'directives': {
        mask
    },
    'components': {
        pagination,
        benefitDateSettings,
        popupModal
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getManualReimbursements();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'filterName': '',
            'filterFromDate': '',
            'filterToDate': '',
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'manualReimbursementList': []
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.initializeDatePickers();
        this.getManualReimbursements();
    },
    'methods': {
        getManualReimbursements () {
            this.axios.post('ManualReimbursement/GetUserManualReimbursementFilterList', {
                'n': this.filterName,
                'fd': convertDateToIso8601(this.filterFromDate),
                'td': convertDateToIso8601(this.filterToDate),
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.manualReimbursementList = list.map((manualReimbursement) => ({
                    'manualReimbursementId': manualReimbursement.mri,
                    'patientName': manualReimbursement.pn,
                    'reimbursementDate': convertDateToDDMMYYYY(manualReimbursement.rd),
                    'requestAmount': manualReimbursement.ra,
                    'actualAmount ': manualReimbursement.aa,
                    'status': manualReimbursement.s,
                    'statusDisplay': getEnumDisplay(genericStatus, manualReimbursement.s),
                    'statusBadgeClass': getEnumBadgeClass(genericStatus, manualReimbursement.s)
                }));
            });
        },
        initializeDatePickers () {
            $(this.$refs.filterFromDate).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });
            $(this.$refs.filterToDate).daterangepicker({
                'singleDatePicker': true,
                'autoApply': true,
                'locale': {
                    'format': 'DD/MM/YYYY'
                }
            });

            $(this.$refs.filterFromDate).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.filterFromDate = picker.startDate.format('DD/MM/YYYY');
                }
            );
            $(this.$refs.filterToDate).on(
                'apply.daterangepicker',
                (ev, picker) => {
                    this.filterToDate = picker.startDate.format('DD/MM/YYYY');
                }
            );
        }
    }
};

</script>

<style>

</style>
